export const TRACKING_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: "pending", label: "Pending" },
  { value: "processing", label: "Processing" },
  { value: "in_transit", label: "In Transit" },
  { value: "shipped", label: "Shipped" },
  { value: "packed", label: "Packed" },
  { value: "checked_in", label: "Checked In" },
  { value: "checked_out", label: "Checked Out" },
  { value: "not_checked", label: "Not Checked" },
  { value: "arrived_at_local_hub", label: "Arrived At Local Hub" },
  { value: "arrived_at_nigeria_hub", label: "Arrived At Nigeria Hub" },
  { value: "arrived_at_uk_hub", label: "Arrived At UK Hub" },
  { value: "arrive_at_the_receiving_hub_center", label: "Arrived At Receiving Hub" },
  { value: "completed", label: "Completed" },
  { value: "canceled", label: "Canceled" },
  { value: "declined", label: "Declined" },
  { value: "order_submitted", label: "Order Submitted" },
  { value: "order_paid_successfully", label: "Order Paid Successfully" },
  { value: "order_payment_failed", label: "Order Payment Failed" },
  { value: "order_verified", label: "Order Verified" },
  { value: "awaiting_shipment", label: "Awaiting Shipment" },
  { value: "flight_sea_departure", label: "Flight / Sea Departure" },
  { value: "custom_clearance", label: "Custom Clearance" },
];

export const formatTrackingStatus = (status: string | null | undefined): string => {
  const match = TRACKING_STATUS_OPTIONS.find(
    (o) => o.value.toLowerCase() === (status || "").toLowerCase()
  );
  return match ? match.label : (status || "N/A").replace(/_/g, " ");
};

export const getTrackingStatusColor = (status: string | null | undefined): string => {
  switch ((status || "").toLowerCase()) {
    case "pending":
    case "not_checked":
    case "awaiting_shipment":
      return "bg-yellow-100 text-yellow-800";
    case "processing":
    case "order_submitted":
    case "order_verified":
      return "bg-blue-100 text-blue-800";
    case "in_transit":
    case "shipped":
    case "flight_sea_departure":
      return "bg-indigo-100 text-indigo-800";
    case "packed":
    case "checked_in":
    case "checked_out":
    case "arrived_at_local_hub":
    case "arrived_at_nigeria_hub":
    case "arrived_at_uk_hub":
    case "arrive_at_the_receiving_hub_center":
    case "custom_clearance":
      return "bg-purple-100 text-purple-800";
    case "completed":
    case "order_paid_successfully":
      return "bg-green-100 text-green-800";
    case "canceled":
    case "declined":
    case "order_payment_failed":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};
